import {
  getRpcUrl,
} from '@/composables/metamask/metamaskHelper';
import { getInstalledMetamaskProvider } from '@/composables/metamask/useMetamaskProvider';
import { ethers } from 'ethers';
import UserCoinBalance from './userCoinBalance';

export default class MetamaskCryptoPayment {
  static async getUserBalance(chainId, coin, tokenAddress, userAddress) {
    try {
      const mmProvider = await getInstalledMetamaskProvider();
      const ethersWeb3Provider = new ethers.providers.Web3Provider(mmProvider);
      const userBalance = new UserCoinBalance(ethersWeb3Provider);
      return await userBalance.getUserBalance(
        chainId,
        coin,
        tokenAddress,
        userAddress,
      );
    } catch (e) {
      await this.getUserBalanceFromFallback(
        chainId,
        coin,
        tokenAddress,
        userAddress,
      );
    }
  }

  // Create a fallback method because the installed provider
  // may not be able to be called in mobile flow
  static async getUserBalanceFromFallback(
    chainId,
    coin,
    tokenAddress,
    userAddress,
  ) {
    try {
      const rpcURL = getRpcUrl(parseInt(chainId, 16));
      const ethersWeb3Provider = new ethers.providers.JsonRpcProvider(rpcURL);
      const userBalance = new UserCoinBalance(ethersWeb3Provider);
      return await userBalance.getUserBalance(
        chainId,
        coin,
        tokenAddress,
        userAddress,
      );
    } catch (e) {
      console.error('Failed to get balance from fallback JSON provider');
      console.error(e);
      return 0;
    }
  }
}
